module.exports = __webpack_public_path__ + "static/media/PaymentColor.962c0b9f.svg";